import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORAL_COMMENT_LIKE_EMAIL_ENABLED = createFcmDetails('coral_comment_like_email_enabled', {
	owner: 'Site Platform',
	context: 'comms stack',
	description: 'Flag to enable/disable the email notification for comment likes.',
	import: false,
});
